import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Contactformulier from "./sections/Contactformulier";
import Locatiekaart from "./sections/Locatiekaart";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Contactformulier />
      <Locatiekaart />
      <Footer />
    </div>;
}